export default __webpack_public_path__ + "src/assets/github.4f5fdb1ed501ec1f481fed733c60dcb6.svg";